import { getBaseApiUrl } from './baseUrlRouteBuilder';

const getMatchesRoute = (year: number) => `${getBaseApiUrl()}/Matches?year=${year}`;

export { getMatchesRoute };
